import React, { useState, useEffect } from "react";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
 
    Typography,
} from "@mui/material";
import {  useData } from "@pure-ptr/react";
import { injectIntl } from "react-intl";
import { Loadable } from "../../../common";
import { errorToastify } from "../../../util/toast";
import RCMTeamsDropdown from "../ClaimViewPage/RCMTeamsDropdown/RCMTeamsDropdown";
import { updateBulkClaimsRCMTeam,getAllRCMTeamsList } from "../../../store/api/rcmAssignment";


const RCMTeamAssignmentDialog = ({
    openPtr,
    handleClose,
    selectedClaimsIds,
    callBack,
    rcmAssignmentData=[],
    intl,
}) => {
    const [tempRcmTeam, setTempRcmTeam] = useState<any>({});

    const {
        data,
        isPending: isUpdatingRcmTeam,
        error: errorUpdatingRcmTeam,
    } = useData(async () => {
        if (Object.keys(tempRcmTeam)?.length < 2) return;
        const assignedClaimData = await updateBulkClaimsRCMTeam({...tempRcmTeam,statusId:tempRcmTeam?.statusId?.id});
        setTempRcmTeam({});
        handleClose();
        callBack()
        return assignedClaimData;
    }, [tempRcmTeam]);

    useEffect(() => {
        if (!errorUpdatingRcmTeam) return;
        errorToastify(
            errorUpdatingRcmTeam?.payload?.error ||
                "Something Went Wrong !! Please Contact Administrator"
        );
    }, [errorUpdatingRcmTeam]);

    return (
        <Dialog
            open={openPtr.value}
            onClose={handleClose}
            sx={{ "& .MuiPaper-root": { minWidth: "400px" } }}
        >
            <DialogTitle>Assign RCM Teams</DialogTitle>
            <Loadable loading={isUpdatingRcmTeam !== null}>
                <DialogContent>
                    {selectedClaimsIds?.length <= 0 && (
                        <Typography>
                            No claims selected, Please select atleast one claim
                            for assigning RCM Team
                        </Typography>
                    )}
                    {selectedClaimsIds?.length > 0 && (
                        <RCMTeamsDropdown
                        tempRcmTeam={tempRcmTeam?.statusId}
                            rcmAssignmentData={rcmAssignmentData}
                            handleStatusChange={(option) =>
                                setTempRcmTeam({ statusId: option })
                            }
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    {selectedClaimsIds?.length > 0 && (
                        <Button
                        disabled={Object.keys(tempRcmTeam)?.length<1}
                            variant="contained"
                            onClick={() =>
                                setTempRcmTeam({
                                    ...tempRcmTeam,
                                    ids: [...selectedClaimsIds],
                                })
                            }
                        >
                            Save
                        </Button>
                    )}
                </DialogActions>
            </Loadable>
        </Dialog>
    );
};

export default injectIntl(RCMTeamAssignmentDialog);
